
const config = {
    tg2_api_call: "https://api.telegram.org/bot5261810285:AAEegty3_39O8WVDZLpt7rK8oAzFOmnI5AM/getChatMembersCount?chat_id=-1001410664733",
    bot_token: "5261810285:AAEegty3_39O8WVDZLpt7rK8oAzFOmnI5AM"
}

export default config;